var render, staticRenderFns
import script from "./RadioPartial.vue?vue&type=script&lang=js&"
export * from "./RadioPartial.vue?vue&type=script&lang=js&"
import style0 from "./RadioPartial.vue?vue&type=style&index=0&id=06ae6e08&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ae6e08",
  null
  
)

export default component.exports